export default __webpack_public_path__ + "static/bg-4old-0c0139445423684ff21f4a5ee6654f6a.png";